import axios from 'axios';
import { apiName } from '@/api/api.js'
let base = apiName;

// 获取所有可用的表单模板列表（下拉选择用）
export const reqFormInstanceTemplateList = params => { return axios({method:'post',url:`${base}/forminstance/gettemplatelist`,params:params}).then(res=>res.data); }

// 根据任务id获取已创建的表单实例
export const reqFormInstanceGetByTask = params => { return axios({method:'post',url:`${base}/forminstance/getbytask`,params:params}).then(res=>res.data); }

// 根据模板创建表单实例
export const reqFormInstanceCreate = params => { return axios({method:'post',url:`${base}/forminstance/create`,params:params}).then(res=>res.data); }

// 删除表单实例（重新选择）
export const reqFormInstanceDelete = params => { return axios({method:'post',url:`${base}/forminstance/delete`,params:params}).then(res=>res.data); }

// 执行人签字
export const reqFormInstanceExecutorSign = params => { return axios({method:'post',url:`${base}/forminstance/executorsign`,params:params}).then(res=>res.data); }

// 审核人签字
export const reqFormInstanceReviewerSign = params => { return axios({method:'post',url:`${base}/forminstance/reviewersign`,params:params}).then(res=>res.data); }

// 保存节点数据（附件、完成时间、结论）
export const reqFormInstanceSaveStepData = params => { return axios({method:'post',url:`${base}/forminstance/savestepdata`,params:params}).then(res=>res.data); }

// 表单实例分页查询列表
export const reqFormInstanceGetList = params => { return axios({method:'post',url:`${base}/forminstance/getlist`,params:params}).then(res=>res.data); }

// 表单环节甘特图数据（按查询条件一次性返回实例及其环节）
export const reqFormInstanceGanttList = params => { return axios({method:'post',url:`${base}/forminstance/ganttlist`,params:params}).then(res=>res.data); }

// 获取当前用户待签字的表单列表
export const reqFormInstanceGetPendingSign = params => { return axios({method:'post',url:`${base}/forminstance/getpendingsign`,params:params}).then(res=>res.data); }

// 删除签字流程中的一个环节
export const reqFormInstanceDeleteStep = params => { return axios({method:'post',url:`${base}/forminstance/deletestep`,params:params}).then(res=>res.data); }

// 驳回上一道签字，将流程返回给上一道环节
export const reqFormInstanceReject = params => { return axios({method:'post',url:`${base}/forminstance/reject`,params:params}).then(res=>res.data); }

// 审核人驳回当前环节执行人已提交的签字，退回执行人重新提交
export const reqFormInstanceRejectCurrent = params => { return axios({method:'post',url:`${base}/forminstance/rejectcurrent`,params:params}).then(res=>res.data); }

// 签字流程被驳回次数统计（按被驳回人分组）
export const reqFormInstanceRejectStat = params => { return axios({method:'post',url:`${base}/forminstance/rejectstat`,params:params}).then(res=>res.data); }

// 某被驳回人的驳回明细
export const reqFormInstanceRejectDetail = params => { return axios({method:'post',url:`${base}/forminstance/rejectdetaillist`,params:params}).then(res=>res.data); }

// 签字流程逾期统计（按执行人分组：逾期次数、逾期时间）
export const reqFormInstanceOverdueStat = params => { return axios({method:'post',url:`${base}/forminstance/overduestat`,params:params}).then(res=>res.data); }

// 某执行人的签字逾期明细
export const reqFormInstanceOverdueDetail = params => { return axios({method:'post',url:`${base}/forminstance/overduedetaillist`,params:params}).then(res=>res.data); }

// 签字表单类型下拉（仅含存在签字环节的模板）
export const reqFormInstanceSignTemplateList = params => { return axios({method:'post',url:`${base}/forminstance/signtemplatelist`,params:params}).then(res=>res.data); }

// 签字表单汇总列表（实例 + 各环节签字情况）
export const reqFormInstanceSignSummaryList = params => { return axios({method:'post',url:`${base}/forminstance/signsummarylist`,params:params}).then(res=>res.data); }
